import { DataSource, Label, Layout } from "@mcleod/components";

export abstract class AutogenLayoutOfferUnsubscribe extends Layout {
    labelResponse: Label;
    sourceOfferUnsubscribe: DataSource;
}
